import { chakra } from '@chakra-ui/react'

export const FormActivationSvg = chakra(
  (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
    return (
      <svg
        viewBox="0 0 196 146"
        width={196}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M185.965 64.713H45.178l-16.915 80.264h140.788l16.914-80.264z"
          fill="#E4E7F6"
          stroke="#293044"
          strokeWidth={0.5}
        />
        <path
          d="M165.809.75h-.25v143.196h3.515V.75h-3.265z"
          fill="#293044"
          stroke="#293044"
          strokeWidth={0.5}
        />
        <path
          d="M53.26.75h-.25v143.196H166.06V.75H53.26z"
          fill="#fff"
          stroke="#293044"
          strokeWidth={0.5}
        />
        <path d="M52.99 15.228H165.75v41.974H52.991V15.228z" fill="#4A61C0" />
        <path
          d="M69.938 29.485h78.837v1.14H69.937v-1.14zM69.938 35.67h78.837v1.14H69.937v-1.14zM85.701 41.86h47.793V43H85.701v-1.14z"
          fill="#8998D6"
        />
        <circle
          cx={112.284}
          cy={54.776}
          r={19.683}
          transform="rotate(45 112.284 54.776)"
          fill="#05CC9A"
          stroke="#293044"
          strokeWidth={0.5}
        />
        <path
          d="M111.029 53.703a3.118 3.118 0 11-4.408-4.41 3.118 3.118 0 014.408 4.41zm-3.45-3.45c-.69.69-.69 1.801 0 2.491.69.69 1.802.69 2.492 0a1.76 1.76 0 000-2.491 1.768 1.768 0 00-2.492 0z"
          fill="#293044"
        />
        <path
          d="M110.741 52.456l-.958.959 7.57 7.57.958-.959-7.57-7.57z"
          fill="#293044"
        />
        <path
          d="M116.683 54.374l-2.108 2.108.766.766 2.108-2.108-.766-.766zM117.257 56.673l-1.245 1.246.766.766 1.246-1.245-.767-.767zM119.077 57.727l-1.629 1.629.767.766 1.629-1.629-.767-.766z"
          fill="#293044"
        />
        <path
          d="M158.827 79.753l-11.266 57.474L166.79 145h2.266l8.548-40.565-18.777-24.682z"
          fill="#C9CCCF"
        />
        <path
          d="M158.827 79.753l-11.266 57.474L166.79 145h2.266l5.084-24.125-15.313-41.122z"
          fill="#293044"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M99.847 79.754H80.929l-5.44-9.888h-57.4L28.316 145h140.739l-10.229-65.246h-58.98z"
          fill="#F6F7FC"
          stroke="#293044"
          strokeWidth={0.5}
        />
        <path
          d="M102.203 112.377h-57.4M103.455 120.713H46.058M71.662 129.047H47.31"
          stroke="#293044"
          strokeWidth={0.5}
        />
        <path
          d="M44.878 27.48v-.7a.673.673 0 00-.656-.658.673.673 0 00-.657.657v.7c0 .351-.307.658-.657.658h-.657a.673.673 0 00-.656.656c0 .35.306.657.656.657h.7c.351 0 .658.307.658.657v.7c0 .35.306.657.656.657.35 0 .657-.306.657-.657v-.7c0-.35.307-.657.657-.657h.7c.35 0 .657-.306.657-.657a.673.673 0 00-.657-.656h-.7c-.35 0-.657-.263-.7-.657zM2.145 43.417v-.438c0-.219-.175-.438-.394-.438-.219 0-.437.176-.437.395v.481a.439.439 0 01-.438.438H.438a.439.439 0 00-.438.438c0 .219.175.438.394.438h.438c.219 0 .438.175.438.394v.438c0 .218.175.437.394.437a.439.439 0 00.438-.438v-.437c0-.22.175-.394.394-.438h.438a.439.439 0 000-.876h-.438c-.175 0-.35-.175-.35-.394zm8.538 19.265v-.35a.3.3 0 00-.306-.307.3.3 0 00-.307.307v.35a.3.3 0 01-.306.306H9.37a.3.3 0 00-.307.307.3.3 0 00.307.306h.35a.3.3 0 01.306.307v.35c0 .175.132.35.307.35s.35-.13.35-.306V63.908c0-.175.132-.35.307-.35h.35a.3.3 0 00.306-.307c0-.175-.13-.35-.306-.35h-.306c-.176.131-.35-.044-.35-.219zm183.544-13.88v-.35a.299.299 0 00-.306-.306.299.299 0 00-.306.306v.35a.3.3 0 01-.307.307h-.35c-.175 0-.351.131-.351.306 0 .176.132.35.307.35H193.308c.175 0 .35.132.35.307v.35a.3.3 0 00.307.307c.175 0 .35-.131.35-.306v-.35a.3.3 0 01.307-.307h.35a.299.299 0 00.306-.307.299.299 0 00-.306-.306h-.35c-.263 0-.395-.175-.395-.35zM34.239 42.718c0 .35-.306.656-.657.656a.673.673 0 01-.657-.656c0-.35.307-.657.657-.657.394 0 .657.306.657.657zM19.79 33.74a.878.878 0 01-.875.876.878.878 0 01-.876-.876c0-.482.394-.876.876-.876.481 0 .875.394.875.876zm168.789-.088c.482 0 .876.394.876.876a.878.878 0 01-.876.876.878.878 0 01-.875-.876c0-.482.394-.876.875-.876z"
          fill="#445072"
        />
      </svg>
    )
  },
)
